import * as React from 'react';

import { Dispatch } from 'redux';
import { connect, DispatchProp } from 'react-redux';
import { upsertFilter, removeFilter } from '../redux-state/actions/filters';
import { number } from 'prop-types';
import { ConnectedPageButton } from '../../common/components/page-button';
import { IAppState } from '../classes/app';
import { goToPage } from '../redux-state/actions/listing';

interface ExternalProps {
    maxNumberOfPages:number
}

interface StateToProps {
    numberOfPages: number;
    currentPage: number;
    isLoading: boolean;
}


interface DispatchToProps {
    goToPrevious: (query: number) => void;
    goToNext: (query: number) => void;
    jumpToPrevious: (query: number, min: number) => void;
    jumpToNext: (query: number, max: number) => void;
}


type PagerProps = ExternalProps & StateToProps & DispatchToProps;


class Pager extends React.Component<PagerProps> {



    toNext(evt: any) {
        this.props.goToNext(this.props.currentPage);
    }

    toPrevious(evt: any) {
        this.props.goToPrevious(this.props.currentPage);
    }


    jumpNext(evt: any) {
        this.props.jumpToNext(this.props.currentPage,this.props.numberOfPages);
    }

    jumpPrevious(evt: any) {
        this.props.jumpToPrevious(this.props.currentPage,1);
    }



    render() {
        if (this.props.numberOfPages == 1) {
            return null;
        }

        if (this.props.numberOfPages <= this.props.maxNumberOfPages) {
            var pages = Array.apply(null, { length: this.props.numberOfPages }).map(Number.call, Number);

            return (
                <div className="adage-search-pagniation">
                    <ul>
                        {pages.map((page, index) => {
                            return <ConnectedPageButton key={index} isActive={this.props.currentPage == index + 1} thisPageNumber={index + 1}></ConnectedPageButton>;
                        })}
                    </ul>
                </div>
            );
        }
        else {

            var pages = Array.apply(null, { length: this.props.numberOfPages }).map(Number.call, Number);


            var start = Math.floor(this.props.currentPage / this.props.maxNumberOfPages) * this.props.maxNumberOfPages;
            var end = start + this.props.maxNumberOfPages < this.props.numberOfPages ? start + this.props.maxNumberOfPages : this.props.numberOfPages;


            return (
                this.props.isLoading ?
                    null
                :
                <div className="adage-search-pagniation">
                    <ul>
                        {
                            pages[start - 1] + 1 > 1 ?
                                <li>
                                    <button className="btn btn-chevron btn-chevron-double" onClick={this.jumpPrevious.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <span className="visually-hidden">Go to first search page</span>
                                    </button>
                                </li>
                                :
                                <li>
                                    <button disabled className="btn btn-chevron btn-chevron-double" onClick={this.jumpPrevious.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <span className="visually-hidden">Go to first search page</span>
                                    </button>
                                </li>
                        }
                        {
                            this.props.currentPage > 1 ?
                                <li>
                                    <button className="btn btn-chevron btn-chevron-left" onClick={this.toPrevious.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <span className="visually-hidden">Go to previous search page</span>
                                    </button>
                                </li>
                                :
                                <li>
                                    <button disabled className="btn btn-chevron btn-chevron-left" onClick={this.toPrevious.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <span className="visually-hidden">Go to previous search page</span>
                                    </button>
                                </li>
                        }

                        {pages.map((page, index) => {

                            if ((index + 1 >= start && index + 1 <= end)
                            ) {
                                return <ConnectedPageButton isActive={this.props.currentPage == index + 1} key={index} thisPageNumber={index + 1}></ConnectedPageButton>;
                            }
                            else { return null; }

                        })}
                        {
                            pages[end - 1] + 1 != this.props.numberOfPages ? <li className="adage-search-pagniation-ellipsis">...</li> : null
                        }
                        {
                            pages[end - 1] + 1 != this.props.numberOfPages ? <ConnectedPageButton isActive={this.props.currentPage == pages[this.props.numberOfPages - 1] + 1} thisPageNumber={pages[this.props.numberOfPages - 1] + 1}></ConnectedPageButton> : null
                        }

                        {
                            this.props.currentPage < this.props.numberOfPages ?
                                <li>
                                    <button className="btn btn-chevron btn-chevron-right" onClick={this.toNext.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                                        </svg>
                                        <span className="visually-hidden">Go to next search page</span>
                                    </button>
                                </li>
                                :
                                <li>
                                    <button disabled className="btn btn-chevron btn-chevron-right" onClick={this.toNext.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                                        </svg>
                                        <span className="visually-hidden">Go to next search page</span>
                                    </button>
                                </li>
                        }
                        {
                            pages[end - 1] + 1 < this.props.numberOfPages ?
                                <li>
                                    <button className="btn btn-chevron btn-chevron-double" onClick={this.jumpNext.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                                        </svg>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                                        </svg>
                                        <span className="visually-hidden">Go to last search page</span>
                                    </button>
                                </li>
                                :
                                <li>
                                    <button disabled className="btn btn-chevron btn-chevron-double" onClick={this.jumpNext.bind(this)}>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                                        </svg>
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                                        </svg>
                                        <span className="visually-hidden">Go to last search page</span>
                                    </button>
                                </li>
                        }

                    </ul>
                </div>
            );
        }
    }
}

export function mapStateToProps(state: IAppState): StateToProps {
    return {
        currentPage: state.listingState.currPage, numberOfPages: state.listingState.numberOfPages, isLoading: state.listingState.currentlyRequesting != null
    }
}

export function mapDispatchToProps(dispatch: Dispatch, ownProps: ExternalProps): DispatchToProps {
    return {
        goToPrevious: (query: number) => {
  
            const current = --query;
            dispatch(upsertFilter("page", current.toString()) as any);
            dispatch(goToPage(current));
        },
        goToNext: (query: number) => {
   
            const current = ++query;
            dispatch(upsertFilter("page", current.toString()) as any);
            dispatch(goToPage(current));
        },
        jumpToNext: (query: number, max: number ) => {

            const current = query + ownProps.maxNumberOfPages;
            if (current > max) {
                dispatch(upsertFilter("page", max.toString()) as any);
                dispatch(goToPage(max));
            } else {
                dispatch(upsertFilter("page", current.toString()) as any);
                dispatch(goToPage(current));

            }
         
          
        },
        jumpToPrevious: (query: number, min: number) => {
  
            const current = query - ownProps.maxNumberOfPages;
            if (current < min) {
                dispatch(upsertFilter("page", "1") as any);
                dispatch(goToPage(min));
            }
            else {
                dispatch(upsertFilter("page", current.toString()) as any);
                dispatch(goToPage(current));

            }
        },
    }
}


export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(Pager);